module.exports = __webpack_public_path__ + "img/play.69067780.svg";